export const getFreeSubscriptionStatus = (from: Date, to: Date) => {
  if (!from || !to) return "unknown";

  const now = new Date();
  const startDate = new Date(from);
  const endDate = new Date(to);

  if (now < startDate) {
    return "pending";
  } else if (now >= startDate && now <= endDate) {
    return "active";
  } else {
    return "completed";
  }
};
